export const env = {
  env: 'prod',
  debug: false,
  sitePath: "https://templated.io",
  apiPath: "https://api.templated.io",
  s3Path: "https://templated-assets.s3.amazonaws.com/",
  plans: {
    starter: { id: "price_1OUcrqCL60mvOF8rwlrwjQGr" },
    scale: { id: "price_1O7gt1CL60mvOF8rXKcImV0P" },
    enterprise: { id: "price_1O7gt2CL60mvOF8rZ73HB3Zy" }
  }
};
